import React from "react";
import ProjectItem from "./projectItem";
import IProject from "../interfaces/IProject";

export interface IProjectListProps {
    items: IProject[];
}

const ProjectList: React.FunctionComponent<IProjectListProps> = ({ items }) => {
    return (
        <>
            {items.map((project: IProject) => <ProjectItem key={project.id} {...project} />)}
        </>
    );
};

export default ProjectList;
